/**
 * index.js - Entry point for auth services
 * 
 * This file exports all auth-related services and utilities
 * to provide a clean public API for the auth module.
 */

import TokenService, { tokenService } from './TokenService';
import TokenStorage from './TokenStorage';
import AuthError from './AuthError';

// Export individual classes for direct import
export { TokenService, TokenStorage, AuthError };

// Default export: same singleton as ./TokenService (never pass apiKey here — constructor
// ignores it but CRA would still inline REACT_APP_DSP_API_KEY if passed).
export default tokenService;
